import React, { useMemo } from "react";

import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  AspectRatio as SizeIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import glassesService from "../../../services/glasses.service";
import GlassesSizesPage from "../glasses-size";
import EmojiObjectsIcon from "@material-ui/icons/EmojiObjects";
import WbIncandescentIcon from "@material-ui/icons/WbIncandescent";
import ObjectModalContent from "../glasses-colors/object";
import ObjectCoverModalContent from "./objectCover";

const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
];

export default function GlassesColorsPage(props) {
  const { data, extra, onRefresh } = props;

  const deleteItem = (item) => {
    return glassesService.deleteGlassesColor(item.id);
  };
  const headerCells = useMemo(
    () => [
      {
        field: "name",
        title: "نام",
        mainField: true,
      },
      {
        field: "price",
        title: "قیمت",
        currency: true,
      },
      // {
      //   field: "count",
      //   title: "موجودی",
      // },
      {
        field: "sizes",
        title: "سایزها (موجودی)",
        disableSort: true,
        renderer: (val) =>
          val
            .map(
              (s) =>
                `${
                  s.hingeToHinge > 139
                    ? "بزرگ"
                    : s.hingeToHinge < 130
                    ? "کوچک"
                    : "متوسط"
                }(${s.count})`
            )
            .join(", "),
      },
      {
        field: "isMain",
        title: "رنگ اصلی",
        renderer: (val) => (val ? "اصلی" : "فرعی"),
      },
      {
        field: "isActive",
        title: "وضعیت",
        renderer: (val) => (val ? "فعال" : "غیر فعال"),
      },
      // color: GlassesGeneralColor;
    ],
    []
  );

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        data={data.colors}
        onRefresh={onRefresh}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: (p) => {
              return (
                <EmojiObjectsIcon
                  color={p.modelObject ? "primary" : undefined}
                />
              );
            },
            tooltip: "مدل سه بعدی",
            modalContent: (p) => <ObjectModalContent {...p} parent={props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: (p) => {
              return (
                <WbIncandescentIcon
                  color={p.modelObjectCover ? "primary" : undefined}
                />
              );
            },
            tooltip: "مدل سه بعدی کاور",
            modalContent: (p) => <ObjectCoverModalContent {...p} parent={props} />,
          },
          {
            icon: <SizeIcon />,
            modalProps: { fullScreen: true },
            refreshOnClose: false,
            modalContent: (props) => (
              <GlassesSizesPage {...props} glasses={data} />
            ),
          },
          {
            modalProps: { maxWidth: "md" },
            icon: <EditIcon />,
            modalContent: (p) => <FormModalContent {...p} parent={data} extra={extra} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "md" },
            icon: <AddIcon />,
            tooltip: "ایجاد رنگ عینک",
            modalContent: (p) => (
              <FormModalContent {...p} parent={data} extra={extra} />
            ),
          },
        ]}
        searchKeys={defaultKeys}
        title={`رنگ‌های عینک ${data.name}`}
      />
    </div>
  );
}
